import * as React from 'react'

import DialogActions  from '@material-ui/core/DialogActions'
import DialogContent  from '@material-ui/core/DialogContent'
import { withFormik } from 'formik'

import { isInMentoring }                                                from '../../project-utils/permissions'
import { ActionButton, InjectAccountType, InlineError, LoadingOverlay } from '../atoms'
import { FullScreenDialog }                                             from '../molecules'
import { CoachingProgramChunk, MentoringProgramChunk }                  from './chunks'
import { genValueMapper }                                               from './form-utils'
import {
  coachingProgramSchema,
  convertCoachingProgram,
  convertMentoringProgram,
  emptyCoachingProgram,
  emptyMentoringProgram,
  mentoringProgramSchema,
}                                                                       from './schemas'

const CreateMentoringProgramForm = withFormik<any, any>({
  validationSchema: mentoringProgramSchema,
  mapPropsToValues: genValueMapper(emptyMentoringProgram),
  handleSubmit:     (values, { props: { onSubmit } }) => {
    onSubmit(convertMentoringProgram(values))
  },
})(
  props => (
    <form onSubmit={props.handleSubmit}>
      <DialogContent>
        <MentoringProgramChunk mode={'create'} {...props} />
        {props.error && <InlineError i18nErrorId={props.error} />}
      </DialogContent>
      <DialogActions>
        <ActionButton
          disabled={props.fetching}
          type={'submit'}
          actionType={'submit'}
          variant={'raised'}
          color={'secondary'}
        />
      </DialogActions>
    </form>
  )
)

const CreateCoachingProgramForm = withFormik<any, any>({
  validationSchema: coachingProgramSchema,
  mapPropsToValues: genValueMapper(emptyCoachingProgram),
  handleSubmit:     (values, { props: { onSubmit } }) => {
    onSubmit(convertCoachingProgram(values))
  },
})(
  props => (
    <form onSubmit={props.handleSubmit}>
      <DialogContent>
        <CoachingProgramChunk mode={'create'} {...props} />
        {props.error && <InlineError i18nErrorId={props.error} />}
      </DialogContent>
      <DialogActions>
        <ActionButton
          disabled={props.fetching}
          type={'submit'}
          actionType={'submit'}
          variant={'raised'}
          color={'secondary'}
        />
      </DialogActions>
    </form>
  )
)

const CreateProgramFormDialog = ({
  isOpen,
  close,
  fetching,
  ...rest
}) => (
  <FullScreenDialog
    close={close}
    isOpen={isOpen}
    title={'createProgram'}
  >
    <LoadingOverlay show={fetching}>
      <InjectAccountType>
        {({ accountType }) => (
          isInMentoring(accountType)
            ? <CreateMentoringProgramForm {...rest} />
            : <CreateCoachingProgramForm {...rest} />
        )}
      </InjectAccountType>
    </LoadingOverlay>
  </FullScreenDialog>
)

export default CreateProgramFormDialog



// WEBPACK FOOTER //
// ./src/components/forms/ProgramCreateForm.tsx